"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledgeProject.list': 'Progetti',
    'route.knowledgeProject.create': 'Aggiungi progetto',
    'route.knowledgeProject.edit': 'Modifica progetto',
};
